































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({
  components: {}
})
export default class MobilePerfilComponent extends Vue {
  @Prop() public information!: any;
  @Prop() public marginBottom!: any;
  @Prop() public marginTop!: any;
  @Prop() public hasCustomMarginBottom!: boolean;
  @Prop() public hasCustomMarginTop!: boolean;
}
